export const ThumbnailConstants = {
  small: {
    width: 256,
    height: 256
  },
  large: {
    width: 1024,
    height: 1024
  }
};
